import { render, staticRenderFns } from "./ra.vue?vue&type=template&id=72782f0a&scoped=true"
import script from "./ra.vue?vue&type=script&lang=js"
export * from "./ra.vue?vue&type=script&lang=js"
import style0 from "./ra.vue?vue&type=style&index=0&id=72782f0a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72782f0a",
  null
  
)

export default component.exports